import { tickPendingCastForEntity } from '../../pendingCastTick.js';
import { tickRyzeRealmWarp } from '../../../domain/abilities/ryzeRealmWarp.js';
import { tickAramChampionRespawn } from '../../../domain/map/aramChampionRespawn.js';

function moveAndCast(entity, others, dt, mapBounds, wallBoxes, bushZones, impassableZones) {
  if (typeof entity.updatePosition === 'function' && !entity.isPassive) {
    entity.updatePosition(dt, others, mapBounds, wallBoxes, bushZones, impassableZones);
  }
  if (typeof entity.updateAbilities === 'function') {
    entity.updateAbilities(dt);
  }
  tickRyzeRealmWarp(entity, dt);
}

/**
 * Player + secondary champions: position and ability cooldowns.
 */
export function updateChampionEntities({
  championEntity,
  secondaries = [],
  allDamageableTargets = [],
  dt = 0,
  mapBounds,
  wallBoxes,
  bushZones,
  impassableZones,
  gameTime = 0
} = {}) {
  if (!championEntity) return;
  tickAramChampionRespawn(championEntity, dt);
  const others = allDamageableTargets.filter((e) => e !== championEntity);
  moveAndCast(championEntity, others, dt, mapBounds, wallBoxes, bushZones, impassableZones);
  tickPendingCastForEntity(championEntity, dt, { allDamageableTargets, gameTime });
  for (const secondary of secondaries) {
    tickAramChampionRespawn(secondary, dt);
    const peers = allDamageableTargets.filter((e) => e !== secondary);
    moveAndCast(secondary, peers, dt, mapBounds, wallBoxes, bushZones, impassableZones);
    tickPendingCastForEntity(secondary, dt, { allDamageableTargets, gameTime });
  }
}
